import { useEffect, useState } from 'react';
import { SERVERS } from '../data/servers';

import { API_URL } from '../api';
const PRICES_URL = `${API_URL}/api/prices`;
const REFRESH_MS = 5 * 60 * 1000;

const staticBySlug = Object.fromEntries(SERVERS.map(s => [s.slug, s]));

// Un seul appel partagé entre tous les composants.
// `servers` vient du backend (catalogue admin) ; le fichier statique sert de secours.
let shared = { servers: SERVERS, updatedAt: null, live: false, ready: false };
let lastFetch = 0;
let pending = null;
const listeners = new Set();

function refresh() {
  if (pending || Date.now() - lastFetch < REFRESH_MS) return;
  pending = fetch(PRICES_URL, { cache: 'no-cache' })
    .then(res => res.json())
    .then(data => {
      if (!data.success) return;
      shared = {
        // Les champs du catalogue statique (type, description…) servent de repli
        // si le backend ne les renvoie pas ; les serveurs ajoutés en admin arrivent ici.
        servers: data.servers.map(api => ({ ...staticBySlug[api.slug], ...api })),
        updatedAt: data.updatedAt,
        live: data.source === 'live',
        ready: true,
      };
      lastFetch = Date.now();
      listeners.forEach(fn => fn(shared));
    })
    .catch(() => { shared = { ...shared, ready: true }; })
    .finally(() => { pending = null; });
}

export default function usePrices() {
  const [state, setState] = useState(shared);

  useEffect(() => {
    listeners.add(setState);
    refresh();
    const timer = setInterval(refresh, REFRESH_MS);
    return () => {
      listeners.delete(setState);
      clearInterval(timer);
    };
  }, []);

  return state;
}
